import $ from 'jquery';

// Class
class GenericCardSlider{
    constructor($root){
        if( !$root.length ) return;

        this.$root = $root;
        this.$track = $root.find('.generic-card-slider__track');
        this.$prevArrow = $root.find('.generic-card-slider__arrow--prev');
        this.$nextArrow = $root.find('.generic-card-slider__arrow--next');
        this.$dots = $root.find('.generic-card-slider__dots');

        this.$track.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            dotsClass: 'generic-card-slider__dots-list',
            prevArrow: this.$prevArrow,
            nextArrow: this.$nextArrow,
            appendDots: this.$dots,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}

$( function(){
    // Maybe iterate over each of these to support multiple on a page.
    $('.generic-card-slider').each(function(){
        new GenericCardSlider($(this));
    });
} );
